"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const pack = require("./pack.cjs");
const unpack = require("./unpack.cjs");
exports.pack = pack.pack;
exports.unpack = unpack.unpack;
//# sourceMappingURL=packer.cjs.map
